"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _FormWrapper = _interopRequireDefault(require("../Forms/FormWrapper"));

var _FilterOption = _interopRequireDefault(require("./FilterOption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const FilterOptionsWrapper = _styledComponents.default.div.withConfig({
  displayName: "FilterOptions__FilterOptionsWrapper",
  componentId: "design-system__sc-3s5k9q-0"
})(["& > ul{max-height:460px;overflow:auto;margin-top:", ";list-style:none;padding:", " 0 0;margin:0;}"], _BaseTheme.default.distance.small, _BaseTheme.default.distance.tiny);

const FilterOptions = _ref => {
  let {
    options
  } = _ref;
  const [term, setTerm] = (0, _react.useState)('');
  const [optionsList, setOptionsList] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    const termsRegex = new RegExp(term.toLowerCase().split(' ').join('|'));
    const result = options.filter(_ref2 => {
      let {
        label
      } = _ref2;
      return label.toLowerCase().match(termsRegex);
    });
    setOptionsList(result);
  }, [options, term]);
  return /*#__PURE__*/_react.default.createElement(FilterOptionsWrapper, null, options.length > 5 && /*#__PURE__*/_react.default.createElement(_FormWrapper.default, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    placeholder: "Search for Options",
    onChange: e => setTerm(e.target.value)
  })), /*#__PURE__*/_react.default.createElement("ul", null, optionsList.map(option => /*#__PURE__*/_react.default.createElement(_FilterOption.default, _extends({
    key: option.label
  }, option)))));
};

FilterOptions.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.object).isRequired
};
var _default = FilterOptions;
exports.default = _default;